const formatSortByValue = {
  dmy: ['dayFormat', 'monthFormat', 'yearFormat'],
  mdy: ['monthFormat', 'dayFormat', 'yearFormat'],
}

const getRuleDateToTextFieldKey = (field = {}) => {
  field = field || {}

  if (typeof field === 'string') return field

  return (
    field.optionValue ||
    field.actionOptionValue ||
    field.field ||
    field.valueKey ||
    field.key ||
    field.fieldKey ||
    field.name ||
    field.fieldName ||
    field.fieldPath ||
    field.target ||
    field.targetKey ||
    field.targetName ||
    field.targetOptionValue ||
    ''
  )
}

const getRuleDateToTextDateField = (action = {}) => {
  let config = action.config && typeof action.config === 'object' ? action.config : {}

  return (
    config.dateField ||
    action.dateField ||
    action.startDateField || {
      source: action.targetSource || 'formData',
      optionValue:
        action.target ||
        action.targetKey ||
        action.key ||
        action.valueKey ||
        action.targetName ||
        action.targetOptionValue ||
        '',
    }
  )
}

const getRuleDateToTextDateValue = (
  designContext = {},
  action = {},
  data = {},
  getRuleValue = () => undefined,
) => {
  let field = getRuleDateToTextDateField(action)
  let fieldKey = getRuleDateToTextFieldKey(field)
  if (!fieldKey) return undefined

  return getRuleValue(
    designContext,
    {
      source: field.source || action.targetSource || 'formData',
      field: fieldKey,
    },
    data,
  )
}

const getRuleDateToTextTarget = (action = {}) => {
  return getRuleDateToTextFieldKey(action.dateText)
}

const getRuleDateToTextFormatSort = (action = {}) => {
  if (Array.isArray(action.formatSort)) return action.formatSort

  if (typeof action.formatSort === 'string' && action.formatSort) {
    return action.formatSort.split(',').map((format) => format.trim())
  }

  return formatSortByValue[action.formatValue] || []
}

const getRuleDateToTextValue = (
  designContext = {},
  action = {},
  dateValue,
) => {
  let { formatDateTime } = designContext
  if (!formatDateTime) return undefined

  let dateList = getRuleDateToTextFormatSort(action)
    .map((format) => action[format])
    .filter((format) => format)
    .map((format) => formatDateTime(dateValue, format))

  if (action.timeFormat) {
    dateList.push(formatDateTime(dateValue, action.timeFormat))
  }

  return dateList.join(' ')
}

export const onRuleDateToText = (
  designContext = {},
  action = {},
  data = {},
  options = {},
) => {
  let {
    getRuleValue = () => undefined,
    setRuleFormData = () => undefined,
  } = options
  let target = getRuleDateToTextTarget(action)
  let dateValue = getRuleDateToTextDateValue(
    designContext,
    action,
    data,
    getRuleValue,
  )

  if (!target || !dateValue) return undefined

  let textValue = getRuleDateToTextValue(designContext, action, dateValue)
  if (textValue === undefined) return undefined

  setRuleFormData(designContext, target, textValue)
  return textValue
}
